var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
import isEqual from "react-fast-compare";
import bytes from "bytes";
import moment from "moment";
import "moment-duration-format";
import { checkAllSvg, alertCircleSvg } from "../../svg";
var SystemCard = /** @class */ (function (_super) {
    __extends(SystemCard, _super);
    function SystemCard() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SystemCard.prototype.render = function () {
        var instance = this.props.instance;
        if (instance.system.length === 0) {
            return null;
        }
        var system = instance.system[0];
        var mem = bytes(bytes.parse(system.memory_kb + "KB"));
        return React.createElement("div", { className: "system-info" },
            React.createElement("div", { className: "info-section " + (system.warn_cpu ? "text-warning" : "") },
                React.createElement("span", { className: "section-title" }, "CPU: "),
                React.createElement("span", null, system.cpu_user + "% us, "),
                React.createElement("span", null, system.cpu_system + "% sy, "),
                React.createElement("span", null, system.cpu_wait + "% wait ")),
            React.createElement("div", { className: "info-section " + (system.warn_mem ? "text-warning" : "") },
                React.createElement("span", { className: "section-title" }, "Memory: "),
                React.createElement("span", null, system.memory_percent + "% [" + mem + "]")));
    };
    return SystemCard;
}(React.Component));
export { SystemCard };
var ProcessCard = /** @class */ (function (_super) {
    __extends(ProcessCard, _super);
    function ProcessCard() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ProcessCard.prototype.render = function () {
        var instance = this.props.instance;
        if (instance.process.length === 0) {
            return null;
        }
        return React.createElement("table", { className: "table table-dark table-sm" },
            React.createElement("thead", null,
                React.createElement("tr", null,
                    React.createElement("th", null, "Process"),
                    React.createElement("th", { style: { width: "90px" } }, "Status"),
                    React.createElement("th", { style: { width: "110px" } }, "Uptime"),
                    React.createElement("th", { style: { width: "100px" } }, "CPU Total"),
                    React.createElement("th", { style: { width: "160px" } }, "Memory Total"))),
            React.createElement("tbody", null, instance.process.map(function (p) {
                if (!p.pid) {
                    return React.createElement("tr", { key: p.name },
                        React.createElement("td", null, p.name),
                        React.createElement("td", null,
                            React.createElement("span", { className: "status-error" }, alertCircleSvg)),
                        React.createElement("td", null),
                        React.createElement("td", null),
                        React.createElement("td", null));
                }
                var mem = bytes(bytes.parse(p.memory_kb + "KB"));
                var uptime = moment.duration(p.uptime, "seconds").format("D[d] H[h] m[m]");
                return React.createElement("tr", { key: p.name },
                    React.createElement("td", null, p.name),
                    React.createElement("td", null,
                        React.createElement("span", { className: "status-ok" }, checkAllSvg)),
                    React.createElement("td", null,
                        React.createElement("span", { className: p.warn_uptime ? "text-warning" : "" }, uptime)),
                    React.createElement("td", null,
                        React.createElement("span", { className: p.warn_cpu ? "text-warning" : "" }, p.cpu + "%")),
                    React.createElement("td", null,
                        React.createElement("span", { className: p.warn_mem ? "text-warning" : "" }, p.memory_percent + "% [" + mem + "]")));
            })));
    };
    return ProcessCard;
}(React.Component));
export { ProcessCard };
var FileSystemCard = /** @class */ (function (_super) {
    __extends(FileSystemCard, _super);
    function FileSystemCard() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FileSystemCard.prototype.render = function () {
        var instance = this.props.instance;
        if (instance.filesystem.length === 0) {
            return null;
        }
        return React.createElement("table", { className: "table table-dark table-sm" },
            React.createElement("thead", null,
                React.createElement("tr", null,
                    React.createElement("th", null, "Filesystem"),
                    React.createElement("th", null, "Space usage"),
                    React.createElement("th", null, "Total space"),
                    React.createElement("th", null, "Free space"))),
            React.createElement("tbody", null, instance.filesystem.map(function (p) {
                if (!p.status) {
                    return React.createElement("tr", { key: p.name },
                        React.createElement("td", null, p.name),
                        React.createElement("td", null,
                            React.createElement("span", { className: "status-error" }, alertCircleSvg)),
                        React.createElement("td", null),
                        React.createElement("td", null));
                }
                var usage = bytes(bytes.parse(p.usage + "MB"));
                var total = bytes(bytes.parse(p.total + "MB"));
                var free = bytes(bytes.parse(p.total - p.usage + "MB"));
                return React.createElement("tr", { key: p.name },
                    React.createElement("td", null, p.name),
                    React.createElement("td", null,
                        React.createElement("span", { className: p.warn_space ? "text-warning" : "" },
                            "  ", p.percent + "% [" + usage + "]")),
                    React.createElement("td", null, total),
                    React.createElement("td", null, free));
            })));
    };
    return FileSystemCard;
}(React.Component));
export { FileSystemCard };
var ProgramCard = /** @class */ (function (_super) {
    __extends(ProgramCard, _super);
    function ProgramCard() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ProgramCard.prototype.render = function () {
        var instance = this.props.instance;
        if (instance.program.length === 0) {
            return null;
        }
        return React.createElement("table", { className: "table table-dark table-sm" },
            React.createElement("thead", null,
                React.createElement("tr", null,
                    React.createElement("th", null, "Program"),
                    React.createElement("th", { style: { width: "90px" } }, "Status"),
                    React.createElement("th", null, "Output"))),
            React.createElement("tbody", null, instance.program.map(function (p) {
                return React.createElement("tr", { key: p.name },
                    React.createElement("td", null, p.name),
                    React.createElement("td", null, p.status ?
                        React.createElement("span", { className: "status-ok" }, checkAllSvg) :
                        React.createElement("span", { className: "status-error" }, alertCircleSvg)),
                    React.createElement("td", { className: p.status ? "" : "text-danger" }, p.output));
            })));
    };
    return ProgramCard;
}(React.Component));
export { ProgramCard };
var InstanceCard = /** @class */ (function (_super) {
    __extends(InstanceCard, _super);
    function InstanceCard() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    InstanceCard.prototype.shouldComponentUpdate = function (nextProps) {
        return !isEqual(this.props.instance, nextProps.instance);
    };
    InstanceCard.prototype.render = function () {
        var instance = this.props.instance;
        if (!instance.status) {
            return React.createElement("div", { className: "instance-card has-alert" },
                React.createElement("div", { className: "instance-card-header" },
                    React.createElement("div", { className: "title" }, instance.name),
                    React.createElement("div", { className: "system-info text-danger" }, "NOT ACCESSIBLE!")));
        }
        var cls = "instance-card";
        if (instance.alert) {
            cls += " has-alert";
        }
        else if (instance.warn) {
            cls += " has-warn";
        }
        return React.createElement("div", { className: cls },
            React.createElement("div", { className: "instance-card-header" },
                React.createElement("div", { className: "title" }, instance.name),
                instance.system.length > 0 && React.createElement(SystemCard, __assign({}, this.props))),
            React.createElement("div", { className: "instance-card-body" },
                instance.process.length > 0 && React.createElement(ProcessCard, __assign({}, this.props)),
                instance.filesystem.length > 0 && React.createElement(FileSystemCard, __assign({}, this.props)),
                instance.program.length > 0 && React.createElement(ProgramCard, __assign({}, this.props))));
    };
    return InstanceCard;
}(React.Component));
export default InstanceCard;
